<template>
  <div class="page-index">
    <!--头部-->
    <HeaderIndex v-show="isFixed==false"></HeaderIndex>
    <!--悬浮头部-->
    <Header v-show="isFixed"></Header>
    <!--轮播图-->
    <div class="banner-box">
      <Banner :width="bodywidth"></Banner>
      <!--颈部-->
      <div class="neck-box">
        <ul class="neck-ul content">
          <li @click.stop="enterAppointment('0')">
            <i class="iconfont icon-signUp"></i>
            <div class="title">
              <p>SignUp</p>
              <p>家长预约</p>
            </div>
          </li>
          <li @click.stop="enterAppointment('1')">
            <i class="iconfont icon-news"></i>
            <div class="title">
              <p>News</p>
              <p>新闻动态</p>
            </div>
          </li>
          <li v-show="!this.$store.state.isMobile">
            <div>The First Step to Higher Education</div>
          </li>
        </ul>
      </div>
    </div>
    <!--img-->
    <div class="banner2-box">
      <img
        src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/home_banner2.jpg"
        alt=""
        class="banner2"
      >
    </div>
    <!--新闻模块-->
    <div class="news-box">
      <div class="content" v-show="!this.$store.state.isMobile">
        <div class="title">
          <span>What's New</span>at Kids 'R' Kids ?
        </div>
        <div class="smallTitle">
          <span @click.stop="enterAppointment('1')">learn more</span>
        </div>
        <news :news="newsData"></news>
      </div>
      <div class="content-mobile" v-show="this.$store.state.isMobile">
        <div class="title">What's New</div>
        <div class="smallTitle">
          <span @click.stop="enterAppointment('1')">learn more</span>
          <div class="smallTitle-right">at Kids 'R' Kids ?</div>
        </div>
        <news :news="newsData"></news>
      </div>
    </div>
    <!--choice-->
    <choice></choice>
    <!--分布-->
    <distribution></distribution>
    <!--底部模块 -->
    <v-footer></v-footer>
  </div>
</template>

<script>
import HeaderIndex from "@/components/header/HeaderIndex"; //头部
import Header from "@/components/header/Header"; //悬浮头部
import Banner from "@/components/index/Banner"; //轮播图
import news from "@/components/news/news"; //新闻
import choice from "@/components/index/choice"; //选择模块
import distribution from "@/components/index/distribution"; //分布模块
import Footer from "@/components/footer/footer"; //底部模块

export default {
  name: "index",
  data() {
    return {
      bodywidth: 1920,
      isFixed: false,
      newsData: []
    };
  },
  mounted() {
    this.getNewData();
    //给window添加一个滚动滚动监听事件
    this.$nextTick(() => {
      this.bodywidth =
        document.body.offsetWidth >= 1200 ? document.body.offsetWidth : 1200;
      window.addEventListener("scroll", this.handleScroll);
    });
  },
  methods: {
    getNewData: function() {
      this.$post("/newsMaintain/list", {
        pageNo: 1,
        pageSize: 10,
        newsType: 1 //1，公司动态；2，园所动态',
      })
        .then(res => {
          if (res.code === "00") {
            this.newsData = res.data.list.slice(0, 3);
          }
        })
        .catch(() => {});
    },
    callResize: function() {
      this.bodywidth = document.body.offsetWidth;
    },
    handleScroll() {
      //改变元素#searchBar的top值
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop <= 50) {
        this.isFixed = false;
      } else {
        this.isFixed = true;
      }
    },
    enterAppointment(val) {
      //跳转到家长预约页面
      let src = "";
      if (val == 0) {
        src = "家长预约";
      } else {
        src = "新闻动态";
      }
      this.$uweb.trackEvent(src, "点击");
      this.$router.push({ name: "appointment", query: { id: val } });
    }
  },
  destroyed() {
    //离开该页面需要移除这个监听的事件
    window.removeEventListener("scroll", this.handleScroll);
  },
  components: {
    HeaderIndex,
    Header,
    Banner,
    news,
    choice,
    distribution,
    "v-footer": Footer
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
 @import "@/assets/css/variables.scss";
.page-index{
  .smallTitle{
      width: 100%;
      text-align: center; 
      margin:20px auto;
      span{
        display: inline-block;
         height: 30px;
         line-height: 30px;
         text-align: center;
         padding: 0 20px;
         background:rgba(186,154,64,1);
         font-size:20px;
         font-family: TimesNewRoman;
         font-style: italic;
         font-weight: 600;
         color:rgba(255,255,255,1);
         cursor: pointer;
      }
    }
  .banner-box{
    width: 100%;
    height: auto;
    position:relative;
  .neck-box{
    width: 100%;
    height: 120px;
    background:rgba(0,52,120,1);
    opacity:0.85;
    position:absolute;
    bottom:0;
    left:0;
    z-index: 2;
    .neck-ul{
      height: 100%;
      li{
        position: relative;
        width:400px;
        height: 100%;
        float:left;
        cursor: pointer;
        i.iconfont{
          display: block;
          width: 80px;
          height: 80px;
          margin-left:96px;
          margin-top: 20px;
          float:left;
        }
        i.iconfont.icon-signUp{
          background: url(../assets/image/icon.png) no-repeat;
          background-position: -110px -10px;
        }
         i.iconfont.icon-news{
          background: url(../assets/image/icon.png) no-repeat;
          background-position: -10px -10px;
        }
        div.title{
          float:left;
          margin-top: 20px;
          margin-left:35px;
          p{
            width: 100%;
            font-size: 18px;
            color: #ffffff;
            margin-top: 10px;
          }
           p:first-child{
             font-size: 20px;
             font-family:TimesNewRomanPSMT;
           }
        }
      }
      li:hover{
        background:rgba(0,40,93,1);
      }
      li::before{
        content: '';
        width:1px;
        height: 120px;
        position: absolute;
        left:0;
        top:0;
        bottom:0;
        background:rgba(21,78,152,1);
      }
      li:last-child{
        cursor: default;
        div{
          position: relative;
          font-size:16px;
          font-family:TimesNewRoman;
          color: #ffffff;
          text-align: center;
          line-height: 120px;
          font-style: italic;
        }
        div::after{
          position: absolute;
          content: '';
          width:40px;
          height: 1px;
          background: #ffffff;
          left:50%;
          bottom:35px;
          margin-left:-20px;
        }
      }
      li:last-child:hover{
        background:none;
      }
      li:last-child::after{
        content: '';
        width:1px;
        height: 120px;
        position: absolute;
        right:0;
        top:0;
        bottom:0;
        background:rgba(21,78,152,1);
      }
    }
  }
  }
  .banner2{
    display: block;
    width: 100%;
    height: auto;
  }

  .news-box{
    width: 100%;
    overflow: hidden;
    .title{
      width: 100%;
      text-align: center;
      font-size: 40px;
      color: $color-primary;
      font-family:TimesNewRoman;
      font-style: italic;
      font-weight: lighter;
      margin-top:100px;
      span{
        font-size: 42px;
        font-weight: 600;
        color: $color-primary;
        font-style: italic;
        margin-right: 10px;
      }
    }
    .news-ul{
      float: left;
      margin-bottom: 100px;
    }
  }
}
@media (min-width: 769px) {
  .banner-box {
    min-width: 1200px;
  }
}
@media (max-width: 768px) {
.page-index{
  .banner-box {
    width: 100%;
  }
  .banner2-box {
    width: 100%;
    overflow: hidden;
    .banner2 {
      width: 133%;
      margin-left: -16%;
    }
  }
  .news-box {
      .content-mobile {
        width: 100%;
        text-align: center;
        .title {
          width: 100%;
          padding-left: 23%;
          box-sizing: border-box;
          text-align: left;
          font-size: 25px;
          font-weight:normal;
          color:rgba(0,52,120,1);
          font-family:TimesNewRomanPS-BoldItalicMT;
          margin-top: 40px;
          display: inline-block;
        }
        .smallTitle {
          width: 100%;
          margin-top: 10px;
          margin-bottom: 22px;
          padding-left: 30%;
          box-sizing: border-box;
          text-align: left;
          align-items: flex-end;
          display: flex;
          span {
            font-size: 10px;
            padding: 3px 4px;
            box-sizing: border-box;
            height: 16px;
            line-height: 10px;
            font-family:TimesNewRomanPS-BoldItalicMT;
            font-weight:normal;
            margin-right: 8px;
          }
          .smallTitle-right {
            font-size:21px;
            font-family:TimesNewRomanPS-ItalicMT;
            font-weight:normal;
            color:rgba(0,52,120,1);
            line-height:20px;
          }
        }
      }
      .news-ul{
        margin-bottom: 0;
      }
    }
  .banner-box .neck-box{
    width: 100%;
    height: 52px;
    position: static;
    .neck-ul{
      height: 100%;
      display: flex;
      li{
        flex: 1;
        width: 50%;
        background:#003478;
        opacity:0.85;
        clear: both;
        display: flex;
        align-items: center;
        justify-content: center;
        i.iconfont{
          margin: 0;
          display: block;
          width: 35px;
          height: 33px;
          margin-right: 5px;
        }
        i.iconfont.icon-signUp{
          background: url(../assets/image/icon.png) no-repeat;
          background-position: -47px -5px;
          background-size: 700px 700px;
        }
         i.iconfont.icon-news{
          background: url(../assets/image/icon.png) no-repeat;
          background-position: -2px -6px;
          background-size: 700px 700px;
        }
        div.title{
          margin: 0;
          p{
            margin: 0;
            font-size:9px;
            font-family:SourceHanSansCN-Regular;
            -webkit-text-size-adjust:none;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:10px;
          }
           p:first-child{
              font-size:10px;
              font-family:TimesNewRomanPSMT;
              padding-bottom: 4px;
           }
        }
      }
      li:hover{
        background:rgba(0,40,93,1);
      }
      li::before{
        content: '';
        width:0px;
      }
    }
  }
}
}
@media screen and (min-width:415px) and (max-width:768px) {
.page-index{
  .news-box {
      .content-mobile {
        width: 100%;
        text-align: center;
        .title {
          width: auto;
          display: inline-block;
          padding-left: 0;
          margin-left: -10%;
        }
        .smallTitle {
          width: 60%;
          align-items: flex-end;
          padding-left: 21%;
          display: flex;
          justify-content: flex-start;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index.vue